<template>
  <div id="contract">
    <div class="policy-title">Talk915 Employment Contract</div>
    <p
      style="line-height: 150%; margin: 0pt 0pt 0.0001pt; text-align: justify; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: bold; font-size: 11.0000pt;"
          >Party A:</span
        ></strong
      ><strong
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: bold; font-size: 11.0000pt;"
          >&nbsp;</span
        ></strong
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 11.0000pt;"
        >Shenzhen Gongshenghe Information Consulting Co., Ltd.</span
      >
    </p>
    <p
      style="line-height: 150%; margin: 0pt 0pt 0.0001pt; text-align: justify; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: bold; font-size: 11.0000pt;"
          >Party B:</span
        ></strong
      ><strong
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: bold; font-size: 11.0000pt;"
          >&nbsp;</span
        ></strong
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 11.0000pt;"
        >{{ userName }}</span
      >
    </p>
    <p
      style="line-height: 150%; margin: 0pt 0pt 0.0001pt; text-align: justify; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: bold; font-size: 10.5000pt;"
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="15"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 14.0000pt;"
          >Agreement Overview</span
        ></strong
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party A hereby engages Party B as a part-time online English/foreign
        language instructor for Talk915 (hereinafter referred to as "the
        Platform"), where Party A serves as the instructional service provider
        for the Platform. Party B agrees to provide part-time teaching services
        in accordance with the terms and conditions stipulated herein. The
        Parties enter into this Agreement based on the principles of equality,
        mutual consent, and consensus through consultation, to be jointly
        observed by both Parties. This Agreement constitutes</span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;an electronically signed Agreement</span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >; the electronic execution by both Parties through Party A's designated
        online signing platform shall have equal legal validity and effect as a
        traditional written signature.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="16"
          style="font-family: Calibri; line-height: 150%; font-weight: bold; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;</span
        ></strong
      >
    </p>
    <h2
      style="margin-top: 13pt; margin-bottom: 13pt; break-after: avoid; text-align: justify; line-height: 172%; font-family: Arial; font-size: 16pt;"
    >
      <strong
        ><span class="15" style="font-family: 'Segoe UI'; font-size: 14.0000pt;"
          >Basic Terms and Conditions</span
        ></strong
      >
    </h2>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 12.0000pt;"
          >Place of Work</span
        ></strong
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party B shall provide instructional services in an independently
        prepared, well-lit, quiet, and tidy dedicated space that complies with
        the hardware and network specifications stipulated in this
        Agreement.</span
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 12.0000pt;"
          >Term of Agreement</span
        ></strong
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >This Agreement shall have a term of one (1) year.</span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >If neither Party raises any written objection within thirty (30) days
        prior to the expiration date hereof, this Agreement shall be
        automatically renewed for a successive one (1) year term; subsequent
        renewals shall follow the same procedure.</span
      >
    </p>
    <p
      style="line-height: 150%; margin: 0pt 0pt 0.0001pt; text-align: justify; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: bold; font-size: 10.5000pt;"
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="15"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 14.0000pt;"
          >I. Obligations and Requirements of Party B (Part-Time
          Engagement)</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >1. Language Proficiency Requirements</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party B shall possess standard pronunciation capabilities in English or
        the applicable foreign language, with proper intonation and
        accentuation, free from pronounced regional accents.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >2. Teaching Experience Requirements</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party B shall demonstrate proficiency in instructing students across
        various age groups and proficiency levels (ranging from beginner to
        advanced), with mastery of teaching modules including listening,
        speaking, reading, and writing.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >3. Work Schedule Requirements</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party B, as a part-time instructor, shall conduct classes in accordance
        with Party A's scheduling requirements. Instructional hours shall be
        from 06:00 to 22:55 Beijing Time, Monday through Sunday (specific
        teaching slots to be determined through mutual consultation based on
        Party B's availability and Party A's instructional demands).</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >4. Hardware and Network Requirements</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >(1) Party B shall maintain a stable internet connection with upload and
        download speeds exceeding 50 Mbps (megabits per second).</span
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >(2) Party B shall ensure that the teaching environment is quiet, clean,
        and free from noise interference to guarantee the orderly conduct of
        instruction.</span
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >(3) Party B shall provide their own computer with fully functional
        audio and video capabilities, equipped with a headset/microphone,
        running on Windows 10 operating system or higher.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >5. Technical Operation Requirements</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party B shall be proficient in the use of Party A's designated online
        teaching platform and virtual classroom facilities. Should technical
        difficulties arise, Party B shall provide timely notification to Party
        A's technical support department.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >6. Qualification and Policy Compliance Requirements</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >All documentation provided by Party B to Party A (including personal
        information and relevant certifications) shall be authentic and valid.
        Party B shall strictly comply with Talk915 Instructor Policies and all
        teaching management regulations prescribed by Party A during the
        instructional process, and shall submit to Party A's teaching guidance
        and supervision.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >7. Teaching Quality Requirements</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party B shall diligently prepare lessons, develop personalized teaching
        plans based on the curriculum syllabus and individual student needs,
        ensuring substantial content and appropriate pedagogical methods. Party
        B shall actively engage with students throughout the instructional
        process, monitor student progress and feedback, and patiently address
        student inquiries. Perfunctory instruction or unjustified class
        interruptions are strictly prohibited.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >8. Student Communication Requirements</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party B shall respect students' cultural backgrounds and learning</span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;<span style="font-family: Calibri;">habits</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >, communicating in a civil and professional manner. Discrimination,
        verbal abuse, personal attacks, or any other inappropriate conduct
        toward students is strictly forbidden.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >9. Compliance with Management Policies</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party B shall strictly comply with all policies and regulations
        established by Party A. Party B is strictly prohibited from violating
        any disciplinary provisions or engaging in any conduct that contravenes
        Party A's core management regulations.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >10. Payment Terms</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party B acknowledges and agrees to accept the compensation payment
        methods and channels designated by Party A, and shall process all
        payment receipts in accordance with Party A's compensation management
        regulations.</span
      >
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="15"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 14.0000pt;"
          >II. Party A's Obligations and Rights</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >1. Compensation Payment Obligations</span
        ></strong
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >(1) Party A shall remunerate Party B based on the actual teaching hours
        completed by Party B;</span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >(2) The </span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><span style="font-family: Calibri;">salary</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;settlement shall follow the calendar month. Party A shall
        disburse the previous month's</span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;<span style="font-family: Calibri;">salary</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;on the 15th day of each month through the designated payment
        platform. In the event of holidays or special circumstances, payment
        dates shall be notified in advance. Currency conversion shall be
        executed based on the exchange rate prevailing on the payment date.
        Party A assumes no liability for salary discrepancies arising from bank
        exchange rate fluctuations or currency conversion fees;</span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >(3) Party B shall provide authentic, accurate, and valid recipient
        account information. Any modification to account information must be
        submitted via Party A's designated channels at least five (5) working
        days in advance through written change application. Party A assumes no
        liability for payment failures, delays, or erroneous transfers to third
        parties resulting from Party B's failure to provide timely notification
        or inaccurate information. In the event such circumstances lead to
        duplicate payment (where Party A cannot recover the misdirected funds
        after re-paying Party B), Party A reserves the right to offset such
        amount against Party B's future </span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><span style="font-family: Calibri;">salary</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;or require refund within a prescribed period.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >2. Teaching Support Obligations</span
        ></strong
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party A shall organize periodic pedagogical training and provide
        guidance and support regarding teaching methodologies and curriculum
        implementation.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >3. Technical Support Obligations</span
        ></strong
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party A shall provide Party B with technical consultation and
        troubleshooting services relating to instruction to ensure the smooth
        conduct of teaching activities.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >4. Management and Supervision Rights</span
        ></strong
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party A reserves the right to monitor and inspect Party B's teaching
        process, teaching quality, and attendance records, with which Party B
        shall cooperate.</span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;</span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party A may issue recommendations for improvement based on student
        feedback and classroom assessments, which Party B shall implement within
        the specified period.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 10.5000pt;"
          >5. Obligation to Provide Information</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; line-height: 150%; background: #ffffff; text-align: justify; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Party A shall promptly notify Party B of teaching policies, course
        arrangements, </span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><span style="font-family: Calibri;">management</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;regulations, and other pertinent information regarding Talk915,
        ensuring Party B's right to information.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; line-height: 150%; background: #ffffff; text-align: justify; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="15"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 14.0000pt;"
          >III. Teaching Evaluation and Incentive/Penalty Mechanisms</span
        ></strong
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <strong
          ><span
            class="17"
            style="font-family: 'Segoe UI'; line-height: 150%; font-size: 12.0000pt;"
            >Complaint Handling</span
          ></strong
        >
      </li>
    </ul>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff;"
      >
        <span
          style="font-family: 'Segoe UI'; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">If </span></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >students file complaints regarding Party B's instructional services,
          and upon verification establishing validity, such complaints shall be
          categorized as either Serious Complaints or General Complaints based
          on severity:</span
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><br /></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Serious Complaints:
        </span>
      </li>
    </ul>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Including but not limited to: adverse attitude toward students,
        violations of teaching content standards, inadequate lesson preparation,
        unauthorized substitution by third parties, engagement in unrelated
        activities during instruction, frequent class cancellations</span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><span style="font-family: Calibri;">, or absence</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >;</span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >General Complaints:
      </span>
    </p>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Including but not limited to: background noise, equipment malfunctions,
        or network instability.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Note:
      </span>
    </p>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Specific complaint categorization standards are detailed in the
        currently effective </span
      ><span
        style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >"Teacher Management Regulations."</span
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party A shall implement corresponding disciplinary measures based on
          complaint classification:</span
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><br /></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >General Complaints:
        </span>
      </li>
    </ul>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Deduction of one to two class fees based on specific circumstances. For
        first-time occurrence, Party A shall issue a formal warning requiring
        rectification within a specified timeframe; accumulation of two (2)
        occurrences within one month shall result in a Serious Complaint;</span
      ><span
        style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Serious Complaints:
      </span>
    </p>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Deduction of fifteen (15) class fees per occurrence. Upon the first
        occurrence, Party A reserves the right to immediately suspend Party B's
        eligibility to receive new bookings for one (1) month observation
        period; eligibility shall be restored upon expiration of the observation
        period </span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><span style="font-family: Calibri;">without</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;further complaints. Upon the second or subsequent occurrence,
        Party A reserves the right to terminate this Agreement and pursue
        corresponding liability</span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;<span style="font-family: Calibri;">with Party B</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >.</span
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <strong
          ><span
            class="17"
            style="font-family: 'Segoe UI'; line-height: 150%; font-size: 12.0000pt;"
            >Absen</span
          ></strong
        ><strong
          ><span
            class="17"
            style="font-family: 宋体; line-height: 150%; font-size: 12.0000pt;"
            ><span style="font-family: Segoe UI;">ce</span></span
          ></strong
        ><strong
          ><span
            class="17"
            style="font-family: 'Segoe UI'; line-height: 150%; font-size: 12.0000pt;"
            >&nbsp;Handling</span
          ></strong
        >
      </li>
    </ul>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >The following circumstances shall constitute absenteeism:</span
        >
      </li>
    </ul>
    <ol
      style="list-style-type: lower-alpha; margin-top: 0.0000pt; margin-bottom: 6.0000pt;"
    >
      <li
        class="MsoNormal"
        style="margin-top: 0.0000pt; margin-right: 0.0000pt; margin-bottom: 6.0000pt; padding: 0pt 0pt 0pt 0pt; text-align: left; line-height: 150%; background: #ffffff;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Failure by Party B to enter the classroom within ten minutes after
          the scheduled class start time, or leaving the classroom ten minutes
          before the scheduled end time, shall be deemed absenteeism.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin-top: 0.0000pt; margin-right: 0.0000pt; margin-bottom: 6.0000pt; padding: 0pt 0pt 0pt 0pt; text-align: left; line-height: 150%; background: #ffffff;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Cancellation </span
        ><span
          style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">requested by </span></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B subsequent to the scheduled start time.</span
        >
      </li>
    </ol>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Absenteeism Penalty:</span
        >
      </li>
    </ul>
    <ol
      style="list-style-type: lower-alpha; margin-top: 0.0000pt; margin-bottom: 6.0000pt;"
    >
      <li
        class="MsoNormal"
        style="margin-top: 0.0000pt; margin-right: 0.0000pt; margin-bottom: 6.0000pt; padding: 0pt 0pt 0pt 0pt; text-align: left; line-height: 150%; background: #ffffff;"
      >
        <span
          style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;"
            >One Absence per month</span
          ></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >:
        </span>
      </li>
    </ol>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Deduction of fifteen (15) class fees.
      </span>
    </p>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><span style="font-family: Calibri;"
          >Party B's eligibility to receive new bookings shall be suspended for
          a period of two (2) weeks to one (1) month (existing confirmed
          bookings shall remain valid).</span
        ></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;Restoration of such eligibility shall be contingent upon
        demonstrated improvement in attendance records during the observation
        period.</span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;<span style="font-family: Calibri;">S</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >hould Party B commit any act of absenteeism during the observation
        period, Party A reserves the right to terminate this Agreement.</span
      >
    </p>
    <ol
      style="list-style-type: lower-alpha; margin-top: 0.0000pt; margin-bottom: 6.0000pt;"
      start="2"
    >
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff;"
      >
        <span
          style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;"
            >Two or more absences per month
          </span></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >:
        </span>
      </li>
    </ol>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Deduction of</span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;</span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >thirty (30) class fees;</span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><br /></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Scenario A: Should Party B's prior performance have been satisfactory,
        eligibility to receive new bookings shall be suspended for one (1)
        month; eligibility shall be reinstated upon expiration of the
        observation period </span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><span style="font-family: Calibri;">without</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;further absenteeism. Should Party B commit an additional instance
        of absenteeism during the observation period, this Agreement shall be
        terminated.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Scenario B: Should Party B's prior performance have been
        unsatisfactory, Party A reserves the right to terminate this Agreement
        immediately.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;</span
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <strong
          ><span
            class="17"
            style="font-family: 'Segoe UI'; line-height: 150%; font-size: 12.0000pt;"
            >Class Cancellation Handling</span
          ></strong
        >
      </li>
    </ul>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Should Party B cancel </span
      ><span
        style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><span style="font-family: Calibri;">the</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;scheduled classes due to special circumstances, deduction rules
        shall apply as follows:</span
      >
    </p>
    <div align="center">
      <table
        style="border-collapse: collapse; width: 426.1pt; border: none; font-family: 'Times New Roman'; font-size: 10pt;"
        border="0"
        cellspacing="0"
      >
        <tbody>
          <tr>
            <td
              style="width: 170.0000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border: 1.0000pt solid #000000;"
              colspan="3"
              valign="center"
              width="226"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <strong
                  ><span
                    style="font-family: 'Microsoft YaHei UI'; color: #000000; font-weight: bold; font-style: normal; font-size: 11.0000pt;"
                    ><span style="font-family: Microsoft YaHei UI;"
                      >Normal class</span
                    ></span
                  ></strong
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width: 87.7000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: 1.0000pt solid #000000; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="116"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >Classification</span
                  ></span
                >
              </p>
            </td>
            <td
              style="width: 168.4000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: 1.0000pt solid #000000; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="224"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >Time before class begin (T)</span
                  ></span
                >
              </p>
            </td>
            <td
              style="width: 170.0000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: 1.0000pt solid #000000; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="226"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >Punishment</span
                  ></span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width: 87.7000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: 1.0000pt solid #000000; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="116"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;">A</span></span
                >
              </p>
            </td>
            <td
              style="width: 168.4000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="224"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >2 hours &le; T &lt;5 days</span
                  ></span
                >
              </p>
            </td>
            <td
              style="width: 170.0000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="226"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: left; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >Deduct one class fee * 35%</span
                  ></span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width: 87.7000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: 1.0000pt solid #000000; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="116"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;">B</span></span
                >
              </p>
            </td>
            <td
              style="width: 168.4000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="224"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >T&lt;2 hours</span
                  ></span
                >
              </p>
            </td>
            <td
              style="width: 170.0000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="226"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: left; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >Deduct one class fee</span
                  ></span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width: 87.7000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: 1.0000pt solid #000000; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="116"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;">C</span></span
                >
              </p>
            </td>
            <td
              style="width: 168.4000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="224"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >T &ge; 5 days</span
                  ></span
                >
              </p>
            </td>
            <td
              style="width: 170.0000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="226"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: left; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >No deduction</span
                  ></span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width: 87.7000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border: none;"
              valign="center"
              width="116"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  >&nbsp;</span
                >
              </p>
            </td>
            <td
              style="width: 168.4000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border: none;"
              valign="center"
              width="224"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  >&nbsp;</span
                >
              </p>
            </td>
            <td
              style="width: 170.0000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border: none;"
              valign="center"
              width="226"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  >&nbsp;</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width: 170.0000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border: 1.0000pt solid #000000;"
              colspan="3"
              valign="center"
              width="226"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <strong
                  ><span
                    style="font-family: 'Microsoft YaHei UI'; color: #000000; font-weight: bold; font-style: normal; font-size: 11.0000pt;"
                    ><span style="font-family: Microsoft YaHei UI;"
                      >Regular class (VIP class)</span
                    ></span
                  ></strong
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width: 87.7000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: 1.0000pt solid #000000; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="116"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;">A</span></span
                >
              </p>
            </td>
            <td
              style="width: 168.4000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: 1.0000pt solid #000000; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="224"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >2 hours &le; T &lt;1 day</span
                  ></span
                >
              </p>
            </td>
            <td
              style="width: 170.0000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: 1.0000pt solid #000000; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="226"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: left; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >Deduct one class fee * 35%</span
                  ></span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width: 87.7000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: 1.0000pt solid #000000; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="116"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;">B</span></span
                >
              </p>
            </td>
            <td
              style="width: 168.4000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="224"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >T&lt;2 hours</span
                  ></span
                >
              </p>
            </td>
            <td
              style="width: 170.0000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="226"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: left; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >Deduct one class fee</span
                  ></span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="width: 87.7000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: 1.0000pt solid #000000; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="116"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;">C</span></span
                >
              </p>
            </td>
            <td
              style="width: 168.4000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="224"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: center; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
                align="center"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >T &ge; 1 days</span
                  ></span
                >
              </p>
            </td>
            <td
              style="width: 170.0000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt; border-left: none; border-right: 1.0000pt solid #000000; border-top: none; border-bottom: 1.0000pt solid #000000;"
              valign="center"
              width="226"
            >
              <p
                style="margin: 0pt 0pt 0.0001pt; text-indent: 0pt; text-align: left; vertical-align: middle; font-family: Calibri; font-size: 10.5pt;"
              >
                <span
                  style="font-family: 'Microsoft YaHei UI'; color: #000000; font-style: normal; font-size: 11.0000pt;"
                  ><span style="font-family: Microsoft YaHei UI;"
                    >No deduction</span
                  ></span
                >
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;</span
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <strong
          ><span
            class="17"
            style="font-family: 宋体; line-height: 150%; font-size: 12.0000pt;"
            ><span style="font-family: Segoe UI;"
              >[Comment to Student]</span
            ></span
          ></strong
        ><strong
          ><span
            class="17"
            style="font-family: 'Segoe UI'; line-height: 150%; font-size: 12.0000pt;"
            >&nbsp;Non-Submission Handling</span
          ></strong
        >
      </li>
    </ul>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Within twenty-four (24) hours following the conclusion of a class
        session, should Party B fail to submit feedback comments to the student, </span
      ><span
        style="font-family: 宋体; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><span style="font-family: Calibri;">the salary</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;for such class shall be disbursed at eighty percent (80%) of the
        standard rate. Accumulation of three (3) instances of </span
      ><span
        style="font-family: 宋体; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        ><span style="font-family: Calibri;">Comments </span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >non-submission within one month shall result in the aforementioned
        deduction and the issuance of a formal warning by Party A. Upon
        accumulation of five (5) or more instances, Party B's eligibility to
        receive new bookings shall be suspended for a minimum period of two (2)
        weeks.</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: Calibri; line-height: 150%; font-size: 12.0000pt;"
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="17"
          style="font-family: Calibri; line-height: 150%; font-size: 12.0000pt;"
          >Special Provisions:</span
        ></strong
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Should Party B's </span
        ><span
          style="font-family: 宋体; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">salary</span></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;for the month be insufficient to cover the deductions for that
          month, the deficiency shall be carried forward and deducted from the
          following month's </span
        ><span
          style="font-family: 宋体; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">salary</span></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >The </span
        ><em
          ><span
            class="18"
            style="font-family: Calibri; line-height: 150%; font-style: italic; font-size: 10.5000pt; background: #ffffff;"
            >Teacher Management Regulations</span
          ></em
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;and other teaching, management, and incentive/disciplinary
          policies issued by Party A from time to time (collectively referred to
          as the </span
        ><strong
          ><span
            class="16"
            style="font-family: Calibri; line-height: 150%; font-weight: bold; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
            >"Platform Rules"</span
          ></strong
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >) constitute an integral and inseparable part of this Agreement and
          shall have the same legal force and effect as this Agreement. Upon
          Party B's initial execution of this Agreement, Party B shall be deemed
          to have fully read, thoroughly understood, and consented to all
          Platform Rules in effect as of the date of execution.</span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;</span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party A reserves the right to amend the Platform Rules from time to
          time as required by operational necessity; such amendments shall be
          published through </span
        ><span
          style="font-family: 宋体; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">obvious ways</span></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;including, but not limited to, platform announcements and
          system notifications.</span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;</span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Should Party B continue to provide teaching services following the
          publication of such amendments, Party B shall be deemed to have
          accepted and agreed to be bound by the revised rules.</span
        ><span
          style="font-family: 宋体; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;</span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Sho</span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >uld Party B disagree with such amendments, Party B reserves the right
          to terminate this Agreement in accordance with Section IV, Subsection
          (4) hereof.</span
        >
      </li>
    </ul>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <strong
          ><span
            class="17"
            style="font-family: 'Segoe UI'; line-height: 150%; font-size: 12.0000pt;"
            >Bonus System</span
          ></strong
        >
      </li>
    </ul>
    <ul style="margin-top: 0.0000pt; margin-bottom: 0.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 0pt 0px; text-align: left; line-height: 150%; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
          >Attendance Bonus</span
        >
      </li>
    </ul>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >Bonus Calculation Formula: Unit Price &times; Number of Classes &times;
        2%</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >Eligibility Criteria:</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        ><span style="font-family: Calibri;">0</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;complaints (including general and serious complaints);</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        ><span style="font-family: Calibri;">0 </span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >absence;</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        ><span style="font-family: Calibri;">0</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;cancellation</span
      ><span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;<span style="font-family: Calibri;">with penalty</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;</span
      ><span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        ><span style="font-family: Calibri;">: </span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >including </span
      ><span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        ><span style="font-family: Calibri;">urgent </span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >cancellations</span
      ><span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;<span style="font-family: Calibri;">(cancellation</span
        ><span style="font-family: 微软雅黑;">＜</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >2 hours in advance</span
      ><span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        ><span style="font-family: Calibri;">)</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >, and cancellations </span
      ><span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        ><span style="font-family: Calibri;">(</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >2 hours</span
      ><span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        ><span style="font-family: 微软雅黑;">＜</span
        ><span style="font-family: Calibri;">cancellation</span
        ><span style="font-family: 微软雅黑;">＜</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >5 days);</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        ><span style="font-family: Calibri;">0</span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;no comment</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;</span
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 0.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 0pt 0px; text-align: left; line-height: 150%; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
          >Course opening bonus</span
        >
      </li>
    </ul>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >Bonus Calculation Formula: &nbsp;Unit price &times; Number of classes
        &times; 2%</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >Eligibility Criteria:</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >The number of opened slots &ge; 200</span
      ><span
        style="font-family: 微软雅黑; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;<span style="font-family: Calibri;">per month </span></span
      ><span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >(The Filipino teachers);</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 18pt; font-family: Calibri; font-size: 10.5pt;"
    >
      <span style="font-family: Calibri; font-size: 10.5000pt;"
        >The number of opened slots &ge; 140 (The Chinese teachers</span
      ><span style="font-family: 微软雅黑; font-size: 10.5000pt;"
        ><span style="font-family: 微软雅黑;">，</span></span
      ><span style="font-family: Calibri; font-size: 10.5000pt;"
        >The European/American teachers)</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >The booking rate &ge; 80%.</span
      >
    </p>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;</span
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 0.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 0pt 0px; text-align: left; line-height: 150%; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
          >Excellent Teacher Award</span
        >
      </li>
    </ul>
    <p
      style="margin: 0pt; text-align: left; line-height: 150%; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >This is an annual evaluation-based award. The bonus amount shall be
        determined based on the company&rsquo;s overall performance and the
        specific grade of the award obtained.</span
      >
    </p>
    <p
      style="margin: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="16"
          style="font-family: Calibri; line-height: 150%; font-weight: bold; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="15"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 16.0000pt;"
          >IV. Agreement Termination</span
        ></strong
      >
    </p>
    <h3
      style="margin-left: 21.25pt; text-indent: -21.25pt; margin-top: 13pt; margin-bottom: 13pt; break-after: avoid; text-align: justify; line-height: 172%; font-family: Calibri; font-size: 16pt;"
    >
      <span style="font-family: 'Segoe UI'; font-size: 12.0000pt;"
        >1.&nbsp;</span
      ><strong
        ><span style="font-family: 'Segoe UI'; font-size: 12.0000pt;"
          >Circumstances Warranting Immediate Termination by Party A</span
        ></strong
      >
    </h3>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B has provided false identification documents, qualification
          certificates, or other credentials;</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B has </span
        ><span
          style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">received</span></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;two (2) or more valid complaints or two (2) or more absen</span
        ><span
          style="font-family: 'Segoe UI'; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">ces</span></span
        ><span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;within one month;</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; color: #101214; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B </span
        ><span
          style="font-family: 宋体; line-height: 150%; color: #101214; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">has </span></span
        ><span
          style="font-family: Calibri; line-height: 150%; color: #101214; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >engage</span
        ><span
          style="font-family: 宋体; line-height: 150%; color: #101214; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">d</span></span
        ><span
          style="font-family: Calibri; line-height: 150%; color: #101214; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;in unauthorized solicitation of students, provide</span
        ><span
          style="font-family: 宋体; line-height: 150%; color: #101214; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">d</span></span
        ><span
          style="font-family: Calibri; line-height: 150%; color: #101214; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;private tutoring services competing with Party A's business
          operations, or divert</span
        ><span
          style="font-family: 宋体; line-height: 150%; color: #101214; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          ><span style="font-family: Calibri;">ed</span></span
        ><span
          style="font-family: Calibri; line-height: 150%; color: #101214; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;students away from the Talk915 platform for instructional
          purposes.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B has disclosed, published, or leaked to any third party </span
        ><span
          class="16"
          style="font-family: Calibri; line-height: 150%; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party A's operational policies, contractual information, remuneration
          standards, teaching materials, or other confidential information
          without Party A's prior written authorization;</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B has made statements in any form to students or third parties
          that defame Party A or its service brand Talk915, or has engaged in
          conduct impairing Party A's lawful rights and interests;</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B has discussed political, violent, territorial
          integrity-related topics, or other sensitive subjects (including
          religious beliefs, human rights, etc.) during instruction, resulting
          in student complaints or adverse effects;</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B has engaged in serious instructional errors, fraudulent
          conduct toward students, charging students additional fees, or other
          acts severely violating professional ethics or impairing student
          interests;</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B has violated other obligations stipulated herein and failed
          to rectify such violations within the prescribed timeframe following
          written notice from Party A, or remains non-compliant following
          rectification;</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B has been subject to criminal liability or deprivation of
          personal liberty, rendering performance of contractual obligations
          impossible.</span
        >
      </li>
    </ul>
    <p
      style="margin: 0pt 0pt 0pt -18pt; padding: 0pt; line-height: 150%; text-align: justify; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-size: 10.5000pt;"
        >&nbsp;</span
      >
    </p>
    <h3
      style="margin-left: 21.25pt; text-indent: -21.25pt; margin-top: 13pt; margin-bottom: 13pt; break-after: avoid; text-align: justify; line-height: 172%; font-family: Calibri; font-size: 16pt;"
    >
      <span style="font-family: 'Segoe UI'; font-size: 12.0000pt;"
        >2.&nbsp;</span
      ><strong
        ><span style="font-family: 'Segoe UI'; font-size: 12.0000pt;"
          >Termination by Mutual Agreement</span
        ></strong
      >
    </h3>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >During the performance of this Agreement, either Party may terminate
        this Agreement through written mutual consent.</span
      >
    </p>
    <h3
      style="margin-left: 21.25pt; text-indent: -21.25pt; margin-top: 13pt; margin-bottom: 13pt; break-after: avoid; text-align: justify; line-height: 172%; font-family: Calibri; font-size: 16pt;"
    >
      <span style="font-family: 'Segoe UI'; font-size: 12.0000pt;"
        >3.&nbsp;</span
      ><strong
        ><span style="font-family: 'Segoe UI'; font-size: 12.0000pt;"
          >Termination During Probationary Period</span
        ></strong
      >
    </h3>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >The probationary period hereunder shall be fifteen (15) days. During
        the probationary period, either Party may terminate this Agreement at
        any time upon written notice to the other Party without liability for
        breach of agreement, provided that three (3) working days' advance
        notice is given to facilitate Party A's arrangement of instructional
        continuity.</span
      >
    </p>
    <h3
      style="margin-left: 21.25pt; text-indent: -21.25pt; margin-top: 13pt; margin-bottom: 13pt; break-after: avoid; text-align: justify; line-height: 172%; font-family: Calibri; font-size: 16pt;"
    >
      <span style="font-family: 'Segoe UI'; font-size: 12.0000pt;"
        >4.&nbsp;</span
      ><strong
        ><span style="font-family: 'Segoe UI'; font-size: 12.0000pt;"
          >Regular Termination (Post-Probation)</span
        ></strong
      >
    </h3>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Following the probationary period, should either Party wish to
        terminate this Agreement, fifteen (15) days' advance written notice
        (including email, messaging applications, or other traceable means)
        shall be given to the other Party, taking effect upon confirmation by
        the recipient. In the event Party B has committed serious issues
        stipulated herein during teaching evaluations, Party A may terminate
        this Agreement immediately without being subject to the advance notice
        requirement.</span
      >
    </p>
    <h3
      style="margin-left: 21.25pt; text-indent: -21.25pt; margin-top: 13pt; margin-bottom: 13pt; break-after: avoid; text-align: justify; line-height: 172%; font-family: Calibri; font-size: 16pt;"
    >
      <span style="font-family: 'Segoe UI'; font-size: 12.0000pt;"
        >5.&nbsp;</span
      ><strong
        ><span style="font-family: 'Segoe UI'; font-size: 12.0000pt;"
          >Obligations after the termination of th</span
        ></strong
      ><strong
        ><span style="font-family: 宋体; font-size: 12.0000pt;"
          ><span style="font-family: Segoe UI;">e Agreement</span></span
        ></strong
      >
    </h3>
    <h3
      style="margin-left: 21.25pt; text-indent: -21.25pt; margin-top: 13pt; margin-bottom: 13pt; break-after: avoid; text-align: justify; line-height: 172%; font-family: Calibri; font-size: 16pt;"
    >
      <span
        style="font-family: Calibri; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >(1)&nbsp;</span
      ><span
        class="16"
        style="font-family: Calibri; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Upon termination of this Service Agreement, Party B shall immediately
        cease conducting any instructional activities in the name of Talk915 and
        shall discontinue use of Talk915 instructional resources and platform
        accounts;</span
      >
    </h3>
    <h3
      style="margin-left: 21.25pt; text-indent: -21.25pt; margin-top: 13pt; margin-bottom: 13pt; break-after: avoid; text-align: justify; line-height: 172%; font-family: Calibri; font-size: 16pt;"
    >
      <span
        style="font-family: Calibri; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >(2)&nbsp;</span
      ><span
        class="16"
        style="font-family: Calibri; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Within seven (7) days after the termination of the agreement, Party B
        shall return to Party A all instructional materials, documentation, and
        other property provided by Party A (if any), and shall cooperate with
        Party A to complete account deactivation, instructional data handover,
        and related formalities;</span
      >
    </h3>
    <h3
      style="margin-left: 21.25pt; text-indent: -21.25pt; margin-top: 13pt; margin-bottom: 13pt; break-after: avoid; text-align: justify; line-height: 172%; font-family: Calibri; font-size: 16pt;"
    >
      <span
        style="font-family: Calibri; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >(3)&nbsp;</span
      ><span
        class="16"
        style="font-family: Calibri; font-weight: normal; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >Following termination, Party B shall continue to abide by the
        confidentiality obligations stipulated herein and shall not disclose
        Party A's confidential information.</span
      >
    </h3>
    <p
      style="margin: 0pt 0pt 0pt -18pt; padding: 0pt; text-align: justify; font-family: Calibri; font-size: 10.5pt;"
    >
      <span style="font-family: Calibri; font-size: 10.5000pt;">&nbsp;</span>
    </p>
    <p
      style="margin: 0pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="16"
          style="font-family: Calibri; line-height: 150%; font-weight: bold; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="15"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 16.0000pt;"
          >V. Confidentiality Agreement</span
        ></strong
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >"Confidential Information" as referred to herein includes, but is not
          limited to, Party A's business plans, operational data, compensation
          standards, contractual terms, teaching materials, teaching
          methodologies, student information, and Talk915 instructor policies
          that have not been publicly disclosed.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >During the term of this Agreement and for a period of two (2) years
          following termination, Party B shall not intentionally or
          unintentionally disclose, disseminate, or leak the aforementioned
          Confidential Information to any third party in any form (including but
          not limited to oral, written, or electronic data), nor utilize such
          Confidential Information for the benefit of Party B or any third
          party.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B acknowledges that Party A's Confidential Information
          constitutes significant commercial assets. Should Party B violate
          these confidentiality obligations causing loss to Party A, Party A
          shall be entitled to demand compensation from Party B, including but
          not limited to direct economic losses, attorneys' fees, litigation
          costs, and other expenses incurred in protecting rights.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >These confidentiality obligations shall survive the termination or
          rescission of this Agreement.</span
        >
      </li>
    </ul>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;</span
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="15"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 16.0000pt;"
          >VI. Intellectual Property Rights</span
        ></strong
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >All intellectual property rights and ownership in course materials,
          courseware, software, platforms, and related instructional resources,
          data, and information (including student information) provided by
          Party A shall vest in Party A or relevant rights holders. Party B is
          granted limited usage rights solely for the purpose of performing
          obligations hereunder.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Any instructional outcomes, improvement suggestions, course feedback,
          and related data generated by Party B in the course of providing
          instructional services utilizing Party A's platform or resources
          (hereinafter referred to as "Instructional Outcomes") shall belong
          exclusively and in their entirety to Party A from the moment of
          creation. Party B is obligated to assist Party A in completing
          confirmation formalities for such rights.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Upon termination of this Agreement, any usage rights Party B may have
          had regarding the aforementioned Instructional Outcomes shall
          immediately cease.</span
        >
      </li>
    </ul>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="15"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 16.0000pt;"
          >&nbsp;</span
        ></strong
      >
    </p>
    <p
      style="margin: 0pt 0pt 6pt; text-indent: 0pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <strong
        ><span
          class="15"
          style="font-family: 'Segoe UI'; line-height: 150%; font-size: 16.0000pt;"
          >VII. Miscellaneous Provisions</span
        ></strong
      >
    </p>
    <ul style="margin-top: 0.0000pt; margin-bottom: 6.0000pt;">
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Party B confirms that, prior to executing this Agreement, Party B has
          carefully reviewed and fully understood all terms and appendices
          hereof, and voluntarily accepts binding by this Agreement; Party B
          further confirms awareness that this Agreement constitutes an
          electronically signed agreement, and execution through Party A's
          designated online platform shall be deemed the authentic expression of
          intent by both Parties having equal legal effect as paper
          signature/seal.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Detailed rules for instructor management outside this Agreement
          constitute an integral and inseparable component of this Agreement
          with equal legal force.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Any disputes arising from the performance of this Agreement shall
          first be resolved through amicable consultation; failing consensus,
          either Party may bring suit before the competent People's Court at
          Party A's domicile.</span
        >
      </li>
      <li
        class="MsoNormal"
        style="margin: 0pt 0pt 6pt 0px; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; text-indent: 14.3333px;"
      >
        <span
          style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
          >Matters not expressly provided for herein may be separately
          negotiated by both Parties and documented through written
          supplementary agreements, which shall possess equal legal validity as
          this Agreement.</span
        >
      </li>
    </ul>
    <p
      style="margin: 0pt 0pt 6pt; padding: 0pt; text-align: left; line-height: 150%; background: #ffffff; font-family: Calibri; font-size: 10.5pt;"
    >
      <span
        style="font-family: Calibri; line-height: 150%; font-style: normal; font-size: 10.5000pt; background: #ffffff;"
        >&nbsp;</span
      >
    </p>
  </div>
</template>
<script>
import './index.less';
import { getUserName } from '@/utils/teacherAuth';
export default {
  data() {
    return {
      userName: getUserName()
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/global-components/TeacherPolicy/Contract/index.vue